import React, { memo,useEffect, useRef, useState } from "react";
import { login } from "../api/LoginApi.js";
import { CustomergetAll } from "api/CustomerApi.js";
import { getBranchId, setBearerToken, setCustomerData, setCustomerId, setCustomerNames } from "../utility/HeaderConfig.js";
import toast from "react-hot-toast";
import { useCartContext } from "context/UseCartContext.js";
import img1 from "images/login/loginBg.jpg";
import img2 from "images/login/signupBg.jpg";
import ForgetPassword from "./ForgetPassword.js";
import { reactLocalStorage } from "reactjs-localstorage";
import SEO from "./headers/Seo.js";
import { generateotp, getTemplateContent, getTemplateDetails, validateOtp } from "api/OtpApi.js";

function LoginModel() {
  const images = [img1, img2];
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [MobileInvalid, setMobileInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState("");
  const [emptyField, setEmptyField] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [CustomerName, setCustomerName] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [forgetPwd, setForgetPwd] = useState(false);
  const { dispatch } = useCartContext();
  const [currentImg, setCurrentImg] = useState(0);
  
  // OTP Integration States
  const [showInitialLogin, setShowInitialLogin] = useState(true);
  const [showOtpCard, setShowOtpCard] = useState(false);
  const [showMainLogin, setShowMainLogin] = useState(false);
  const [customerInfo, setCustomerInfo] = useState("");
  const [otp, setOtp] = useState("");
  const [otpId, setOtpId] = useState("");
  const [templateContent, setTemplateContent] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [notExit, setnotExit] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  
  const mobileInputRef = useRef(null);

  useEffect(() => {
    // Lock body scroll
    document.body.style.overflow = "hidden";
    getTemplateInfo();
    const rem = reactLocalStorage.get("rememberedUser");
    if (rem) {
      try {
        const { mobileNo: m, password: p } = JSON.parse(rem);
        setMobileNo(m); 
        setPassword(p); 
        setRememberMe(true);
      } catch (e) {}
    }
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImg((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  // eslint-disable-next-line
  }, []);

  const getTemplateInfo = () => {
    const filterData = "REGISTRATION_OTP";
    getTemplateDetails(filterData).then((data) => {
      setTemplateId(data.response);
      getTemplateContent({ name: filterData }).then((d) => {
        setTemplateContent(d.response.content[0]?.content);
      });
    });
  };

  const close = () => dispatch({ type: "MODAL", payload: false });

  // Handle password change (only numbers, max 4 digits)
  const handlePasswordChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setPassword(value);
    setPasswordInvalid("");
    setEmptyField(false);
  };

  // OTP Generation
  const generateOtpDetails = (customerData) => {
    setSendingOtp(true);
    generateotp(JSON.stringify({
      communicationChannel: "SMS",
      message: templateContent,
      remark: "-",
      searchData: customerData,
      senderType: "OTP_CUSTOMER",
      templateId
    })).then((data) => {
      setSendingOtp(false);
      if (data.response) {
        setOtpId(data.response);
        toast.success("OTP sent to your mobile number");
        setShowInitialLogin(false);
        setShowOtpCard(true);
      }
    }).catch((error) => {
      setSendingOtp(false);
      toast.error("Failed to send OTP. Please try again.");
      console.error(error);
    });
  };

  // Resend OTP
  const handleResendOtp = () => {
    setSendingOtp(true);
    generateotp(JSON.stringify({
      communicationChannel: "SMS",
      message: templateContent,
      remark: "-",
      searchData: customerInfo,
      senderType: "OTP_CUSTOMER",
      templateId
    })).then((data) => {
      setSendingOtp(false);
      if (data.response) {
        setOtpId(data.response);
        toast.success("OTP resent successfully");
      }
    }).catch((error) => {
      setSendingOtp(false);
      toast.error("Failed to resend OTP. Please try again.");
      console.error(error);
    });
  };

  // Verify OTP
  const handleVerifyOtp = () => {
    if (otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }
    validateOtp(otpId, otp).then((data) => {
      if (data?.response === true) {
        toast.success("OTP Verified Successfully!");
        setShowOtpCard(false);
        setShowMainLogin(true);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    });
  };

  // OTP Input Handler
  const handleOtpChange = (e) => {
    const v = e.target.value.replace(/\D/g, "");
    if (v.length <= 6) setOtp(v);
  };

  const handleOtpKeyPress = (e) => {
    if (e.key === "Enter" && otp.length === 6) {
      handleVerifyOtp();
    }
  };

  // Mobile Verification
  const handleVerify = async () => {
    const mobileReg = /^[0-9]{10}$/;
    if (!mobileReg.test(mobileNo)) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }
    try {
      const respData = await CustomergetAll({
        mobile: `${mobileNo}`,
        branchDetailsEntity: getBranchId()
      });
      if (respData.response && respData.response.length > 0) {
        setCustomerInfo(respData.response[0]?.id);
        generateOtpDetails(respData.response[0]?.id);
      } else {
        toast.error("Mobile Number Does Not Exist. Please Sign Up to Login",{ duration: 1500, position: "top-right" });
        setTimeout(() => dispatch({ type: "MODAL", payload: "register" }), 1200);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error checking mobile number");
    }
  };

  const handleMobileChange = (e) => {
    const v = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobileNo(v);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && mobileNo.length === 10) {
      handleVerify();
    }
  };

  const submitForm = (e) => {
    e.preventDefault();
    
    // Validate password is exactly 4 digits
    if (password.length !== 4) {
      setPasswordInvalid("Password must be exactly 4 digits");
      toast.error("Password must be exactly 4 digits");
      setEmptyField(true);
      return;
    }
    
    if (rememberMe) reactLocalStorage.set("rememberedUser", JSON.stringify({ mobileNo, password }));
    else reactLocalStorage.remove("rememberedUser");
    postAjaxRequest();
  };

  const postAjaxRequest = () => {
    const mobileReg = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    setMobileInvalid(!mobileReg.test(mobileNo) && mobileNo !== "");

    if (!mobileNo || !password || !mobileReg.test(mobileNo)) {
      setEmptyField(true);
      return;
    }

    // Additional password validation
    if (password.length !== 4) {
      setPasswordInvalid("Password must be exactly 4 digits");
      toast.error("Password must be exactly 4 digits");
      return;
    }

    setLoading(true);
    login(JSON.stringify({ username: mobileNo, password })).then(
      (data) => {
        if (data?.authStatus?.toLowerCase() === "success" && data.token) {
          setBearerToken(data.token);
          setPasswordInvalid("");
          getCustomer();
        } else {
          setLoading(false);
          setPasswordInvalid("Invalid credentials. Please try again.");
        }
      },
      (err) => {
        setLoading(false);
        if (err.response) {
          const msg = err.response.data.errorMsg
            ? err.response.data.errorMsg
            : err.response.data.displayMessage
          setPasswordInvalid(msg);
        } else {
          setPasswordInvalid("Login failed. Please check your connection.");
        }
      }
    );
  };

  const getCustomer = async () => {
    const respData = await CustomergetAll({ mobile: mobileNo, branchDetailsEntity: getBranchId() });
    try {
      if (respData.response.length === 1) {
        setCustomerId(respData.response[0].id);
        setCustomerNames(respData.response[0].name);
        setCustomerData(respData.response[0])
        toast.success("Welcome back! Signed in.", { duration: 1500, position: "top-right" });
        dispatch({ type: "LOGIN", payload: respData.response });
        setTimeout(() => dispatch({ type: "MODAL", payload: false }), 1000);
      } else if (respData.response.length > 1) {
        setShowModal(true);
        setCustomerName(respData.response);
      } else {
        setnotExit(true);
        toast.error("Customer not found. Please register.");
        setTimeout(() => dispatch({ type: "MODAL", payload: "register" }), 1200);
      }
    } catch (e) { 
      console.log(e);
      toast.error("Error fetching customer details");
    }
    setLoading(false);
  };

  const selectUser = (e) => {
    setCustomerNames(e.target.options[e.target.selectedIndex].text);
    const selectedCustomer = CustomerName.find(c => c.id === e.target.value);
    setCustomerId(e.target.value);
    setCustomerData(selectedCustomer)
    toast.success("Signed in!", { duration: 1000, position: "top-right" });
    dispatch({ type: "LOGIN", payload: [{ id: e.target.value }] });
    setTimeout(() => dispatch({ type: "MODAL", payload: false }), 1000);
  };

  return (
    <>
      <SEO title="Sign In — Sibiraja Nagai Maaligai LLP" description="Sign in to your account." name="Sibiraja Nagai Maaligai LLP" type="article" />

      {/* Full-screen fixed overlay — rendered AT ROOT of page */}
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 99999,
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "16px",
          animation: "ejFadeIn .2s ease",
        }}
      >
        {/* Backdrop */}
        <div
          onClick={close}
          style={{
            position: "absolute", inset: 0,
            background: "rgba(0,0,0,.55)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
          }}
        />

        {/* Modal card */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "relative", zIndex: 1,
            background: "#fff",
            borderRadius: 20,
            boxShadow: "0 24px 80px rgba(0,0,0,.2)",
            width: "100%", maxWidth: 800,
            maxHeight: "90vh",
            display: "flex",
            overflow: "hidden",
            animation: "ejScaleIn .24s cubic-bezier(.16,1,.3,1)",
          }}
        >
          {/* Left image */}
          <div className="ej-modal-side-img-wrap" style={{ width: "42%", flexShrink: 0, position: "relative", overflow: "hidden", alignSelf: "stretch", minHeight: 0 }}>
            <img src={images[currentImg]} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(0,0,0,.75) 0%,rgba(0,0,0,.1) 60%)", display: "flex", alignItems: "flex-end", padding: 28 }}>
              <div>
                <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: "#e0c17e" }}>Timeless Jewellery</p>
                <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 26, fontWeight: 500, color: "#fff", margin: 0 }}>Crafted for you</h2>
              </div>
            </div>
          </div>

          {/* Right form */}
          <div style={{ flex: 1, padding: "40px 36px", overflowY: "auto", position: "relative", minHeight: 0 }}>
            {/* Close */}
            <button onClick={close} style={{ position: "absolute", top: 16, right: 16, width: 30, height: 30, borderRadius: "50%", background: "#f2f2f7", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#6c6c70" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>

            {/* Step 1: Mobile Entry */}
            {showInitialLogin && (
              <>
                <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#6b5330", margin: "0 0 6px" }}>Welcome Back</p>
                <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 28, fontWeight: 500, color: "#6b5330", margin: "0 0 6px" }}>Sign In</h2>
                <p style={{ fontSize: 13, color: "#f6d78e", margin: "0 0 24px" }}>Enter your mobile number to continue</p>

                <div style={{ marginBottom: 20 }}>
                  <label style={labelStyle}>Mobile Number</label>
                  <div style={{ position: "relative" }}>
                    <span style={prefixStyle}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 9.91a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.34 1.85.574 2.81.7A2 2 0 0122 16.92z"/>
                      </svg>
                    </span>
                    <input 
                      ref={mobileInputRef}
                      type="tel" 
                      value={mobileNo} 
                      onChange={handleMobileChange}
                      onKeyPress={handleKeyPress}
                      placeholder="10-digit mobile number"
                      maxLength={10}
                      disabled={sendingOtp}
                      style={{ 
                        ...inputStyle, paddingLeft: 42, 
                        borderColor: emptyField && !mobileNo ? "#e53e3e" : "#e5e5ea",
                        opacity: sendingOtp ? 0.6 : 1,
                        cursor: sendingOtp ? "not-allowed" : "text"
                      }} 
                    />
                  </div>
                  {emptyField && !mobileNo && <span style={errStyle}>Mobile number is required</span>}
                </div>

                <button 
                  type="button" 
                  onClick={handleVerify} 
                  disabled={mobileNo.length !== 10 || sendingOtp}
                  style={{
                    ...btnStyle,
                    background: (mobileNo.length === 10 && !sendingOtp) ? "#6b5330" : "#ccc",
                    cursor: (mobileNo.length === 10 && !sendingOtp) ? "pointer" : "not-allowed"
                  }}
                >
                  {sendingOtp ? "Sending..." : "Send OTP"}
                </button>

                <p style={{ fontSize: 13, color: "#0e0c0c", textAlign: "center", marginTop: 16 }}>
                  New to Sibiraja Nagai Maaligai LLP?{" "}
                  <button style={linkBtnStyle} onClick={() => dispatch({ type: "MODAL", payload: "register" })}>Create account</button>
                </p>
              </>
            )}

            {/* Step 2: OTP Verification */}
            {showOtpCard && (
              <>
                <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#6b5330", margin: "0 0 6px" }}>Verify OTP</p>
                <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 28, fontWeight: 500, color: "#6b5330", margin: "0 0 6px" }}>Enter OTP</h2>
                <p style={{ fontSize: 13, color: "#f6d78e", margin: "0 0 24px" }}>
                  Code sent to <strong style={{ color: "#6b5330" }}>+91 {mobileNo}</strong>
                </p>

                <div style={{ marginBottom: 20 }}>
                  <label style={labelStyle}>One-Time Password</label>
                  <input 
                    type="text"
                    pattern="[0-9]{6}"
                    inputMode="numeric"
                    autoComplete="off"
                    value={otp}
                    onChange={handleOtpChange}
                    onKeyPress={handleOtpKeyPress}
                    style={{ 
                      ...inputStyle, 
                      textAlign: "center", 
                      letterSpacing: "0.5em", 
                      fontSize: 22, 
                      fontWeight: 700,
                      padding: "16px 14px"
                    }}
                    placeholder="• • • • • •"
                    maxLength={6}
                  />
                  <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 12 }}>
                    {Array.from({ length: 6 }).map((_, i) => (
                      <div 
                        key={i} 
                        style={{ 
                          width: 10, height: 10, borderRadius: "50%", 
                          background: i < otp.length ? "#6b5330" : "rgba(79,50,103,0.2)", 
                          transition: "background 0.2s" 
                        }} 
                      />
                    ))}
                  </div>
                </div>

                <button 
                  type="button" 
                  onClick={handleVerifyOtp} 
                  disabled={otp.length !== 6}
                  style={{
                    ...btnStyle,
                    background: otp.length === 6 ? "#6b5330" : "#ccc",
                    cursor: otp.length === 6 ? "pointer" : "not-allowed"
                  }}
                >
                  Verify & Sign In
                </button>

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
                  <button 
                    onClick={() => { 
                      setShowOtpCard(false); 
                      setShowInitialLogin(true); 
                      setOtp("");
                    }} 
                    disabled={sendingOtp}
                    style={{ 
                      ...linkBtnStyle, 
                      textDecoration: "none", 
                      fontSize: 13,
                      opacity: sendingOtp ? 0.5 : 1,
                      pointerEvents: sendingOtp ? "none" : "auto"
                    }}
                  >
                    ← Back
                  </button>
                  <button 
                    onClick={handleResendOtp} 
                    disabled={sendingOtp}
                    style={{ 
                      ...linkBtnStyle, 
                      fontSize: 13,
                      opacity: sendingOtp ? 0.5 : 1,
                      pointerEvents: sendingOtp ? "none" : "auto"
                    }}
                  >
                    {sendingOtp ? "Sending..." : "Resend OTP"}
                  </button>
                </div>
              </>
            )}

            {/* Step 3: Password Login */}
            {showMainLogin && !forgetPwd && (
              <>
                <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#6b5330", margin: "0 0 6px" }}>Enter Password</p>
                <h2 style={{ fontFamily: "var(--font-display,Georgia,serif)", fontSize: 28, fontWeight: 500, color: "#6b5330", margin: "0 0 6px" }}>Welcome Back</h2>
                <p style={{ fontSize: 13, color: "#f6d78e", margin: "0 0 24px" }}>Enter your 4-digit password to continue</p>

                <form onSubmit={submitForm} noValidate>
                  {/* Mobile Display */}
                  <div style={{ marginBottom: 14 }}>
                    <label style={labelStyle}>Mobile Number</label>
                    <div style={{ position: "relative" }}>
                      <span style={prefixStyle}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 9.91a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.34 1.85.574 2.81.7A2 2 0 0122 16.92z"/>
                        </svg>
                      </span>
                      <input 
                        type="tel" 
                        value={mobileNo} 
                        readOnly
                        style={{ 
                          ...inputStyle, paddingLeft: 42, 
                          borderColor: (emptyField && !mobileNo) || MobileInvalid || passwordInvalid ? "#e53e3e" : "#e5e5ea",
                          background: "#f5f5f5"
                        }}
                      />
                    </div>
                    {notExit && <span style={errStyle}>Customer not found. Please register!</span>}
                  </div>

                  {/* Password */}
                  <div style={{ marginBottom: 14 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                      <label style={labelStyle}>Password (4-digit numeric)</label>
                      <button 
                        type="button" 
                        onClick={() => setForgetPwd(true)} 
                        style={{ fontSize: 11.5, color: "#6b5330", background: "none", border: "none", padding: 0, cursor: "pointer" }}
                      >
                        Forgot password?
                      </button>
                    </div>
                    <div style={{ position: "relative" }}>
                      <span style={prefixStyle}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="11" width="18" height="11" rx="2"/>
                          <path d="M7 11V7a5 5 0 0110 0v4"/>
                        </svg>
                      </span>
                      <input 
                        type={showPassword ? "text" : "password"} 
                        inputMode="numeric"
                        pattern="[0-9]{4}"
                        value={password} 
                        onChange={handlePasswordChange} 
                        placeholder="Enter 4-digit password"
                        maxLength={4}
                        style={{ 
                          ...inputStyle, paddingLeft: 42, paddingRight: 42, 
                          borderColor: (emptyField && !password) || passwordInvalid ? "#e53e3e" : "#e5e5ea" 
                        }} 
                      />
                      <button 
                        type="button" 
                        onClick={() => setShowPassword((v) => !v)} 
                        style={{ 
                          position: "absolute", right: 12, top: "50%", 
                          transform: "translateY(-50%)", background: "none", 
                          border: "none", cursor: "pointer", color: "#98989d", display: "flex" 
                        }}
                      >
                        {showPassword ? (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                          </svg>
                        ) : (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                          </svg>
                        )}
                      </button>
                    </div>
                    {emptyField && !password && <span style={errStyle}>Password is required</span>}
                    {passwordInvalid && <span style={errStyle}>{passwordInvalid}</span>}
                    {password && password.length > 0 && password.length < 4 && !passwordInvalid && (
                      <span style={errStyle}>Password must be 4 digits (current: {password.length}/4)</span>
                    )}
                  </div>

                  {/* Remember */}
                  <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#48484a", cursor: "pointer", marginBottom: 16 }}>
                    <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} style={{ accentColor: "#c9a34d" }} />
                    Remember me
                  </label>

                  <button type="submit" disabled={Loading} style={btnStyle}>
                    {Loading ? "Signing in…" : "Sign In"}
                  </button>
                </form>

                <p style={{ fontSize: 13, color: "#0e0c0c", textAlign: "center", marginTop: 14 }}>
                  New to Sibiraja Nagai Maaligai LLP?{" "}
                  <button style={linkBtnStyle} onClick={() => dispatch({ type: "MODAL", payload: "register" })}>Create account</button>
                </p>
              </>
            )}

            {/* Forgot Password */}
            {forgetPwd && <ForgetPassword userNumber={mobileNo} onBack={() => setForgetPwd(false)} />}
          </div>
        </div>
      </div>

      {/* Multi-user select */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 100000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={() => setShowModal(false)} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,.5)" }} />
          <div style={{ position: "relative", zIndex: 1, background: "#fff", borderRadius: 16, padding: 28, width: "100%", maxWidth: 360, boxShadow: "0 20px 60px rgba(0,0,0,.2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h6 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Select Account</h6>
              <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "#6c6c70" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <select onChange={selectUser} defaultValue="" style={{ ...inputStyle, width: "100%", marginBottom: 0 }}>
              <option value="" disabled>Select account</option>
              {CustomerName.map((o, i) => <option key={i} value={o.id}>{o.name}</option>)}
            </select>
          </div>
        </div>
      )}

      <style>{`
        @keyframes ejFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes ejScaleIn { from { opacity: 0; transform: scale(.96); } to { opacity: 1; transform: scale(1); } }
        @media (max-width: 600px) {
          .ej-modal-side-img-wrap { display: none !important; }
        }
      `}</style>
    </>
  );
}

const labelStyle = { display: "block", fontSize: 11, fontWeight: 600, color: "#6d551e", letterSpacing: ".07em", textTransform: "uppercase", marginBottom: 6 };
const prefixStyle = { position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "#6d551e", pointerEvents: "none", display: "flex", alignItems: "center" };
const inputStyle = { display: "block", width: "100%", padding: "12px 14px", fontFamily: "inherit", fontSize: 14, color: "#6d551e", background: "#fafafa", border: "1.5px solid #e5e5ea", borderRadius: 8, outline: "none", transition: "border-color .14s, box-shadow .14s" };
const errStyle = { display: "block", fontSize: 11.5, color: "#e53e3e", marginTop: 5 };
const btnStyle = { display: "flex", alignItems: "center", justifyContent: "center", width: "100%", padding: 13, background: "#6b5330", color: "#fff", fontSize: 14, fontWeight: 600, letterSpacing: ".05em", border: "none", borderRadius: 8, cursor: "pointer", transition: "background .14s" };
const linkBtnStyle = { color: "#e0c17e", fontWeight: 600, background: "none", border: "none", padding: 0, cursor: "pointer", textDecoration: "underline", fontSize: "inherit" };

export default memo(LoginModel);